import { cn } from '@shared/utils';
// import CrownIcon from '@assets/images/spinner/crown.svg';
import style from './spinner.module.scss';

interface SpinnerProps {
  embedded?: boolean;
  position?: boolean;
  little?: boolean;
}

export const Spinner = (props: SpinnerProps) => {
  return (
    <div
      className={cn(
        'flex items-center justify-center',
        props.position && 'fixed top-1/2 left-1/2 z-1200 translate-x-[-50%] translate-y-[-50%]',
        props.embedded && 'absolute top-0 left-0 h-full w-full',
      )}
    >
      <div
        className={cn(
          'relative flex h-7 w-7 justify-center',
          props.embedded && 'h-full w-full items-center',
          props.little && 'mx-10 mt-10 h-5 w-20 items-center',
        )}
      >
        <div
          className={cn(
            'relative h-7 w-7 rounded-full border-t border-r border-b border-l border-t-[#969696] border-r-[#969696] border-b-[#969696] border-l-[#d3c39f]',
            props.embedded && 'h-8 w-8 border-[3px]',
            props.little && 'h-20 w-20',
            style.spinner,
          )}
        />
        <div className={cn('absolute flex h-full flex-col items-center justify-center', props.embedded && 'h-6 w-6')}></div>
      </div>
    </div>
  );
};
